"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTreePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var TreePicker_1 = require("../TreePicker");
var enums_1 = require("../../enums");
var Icon_1 = require("../../ui/Icon");
var IconSymbols_1 = require("../../generated/IconSymbols");
var SearchTreePicker = function (props) {
    var checkTreeProps = props.checkTreeProps, data = props.data, showButtonOpts = props.showButtonOpts, onItemSelected = props.onItemSelected;
    var _a = (0, react_1.useState)(data), treeData = _a[0], setTreeData = _a[1];
    var _b = (0, react_1.useState)(""), searchTerm = _b[0], setSearchTerm = _b[1];
    var handleChange = function (e) {
        setSearchTerm(e.target.value);
        filterOptions(e.target.value);
    };
    var filterOptions = function (val) {
        var lowerCaseVal = val.toLowerCase();
        var filteredData = data.filter(function (e) { return e.label.toLowerCase().includes(lowerCaseVal); });
        getRelatives(filteredData);
    };
    var getRelatives = function (filteredData) {
        var ids = filteredData.map(function (e) { return e.id; });
        filteredData.map(function (e) {
            if (e.parent) {
                ids = getParents(e.parent, ids);
            }
            if (e.hasChildren) {
                ids = getChildren(e.id, ids);
            }
        });
        var newData = data.filter(function (e) { return ids.includes(e.id); });
        setTreeData(newData);
    };
    var getChildren = function (parentId, ids) {
        var children = data.filter(function (c) { return c.parent === parentId; });
        children.forEach(function (c) {
            ids = __spreadArray(__spreadArray([], ids, true), [c.id], false);
            if (!c.hasChildren)
                return;
            ids = getChildren(c.id, ids);
        });
        return ids;
    };
    var getParents = function (parentId, ids) {
        var parent = data.find(function (c) { return c.id === parentId; });
        ids = __spreadArray(__spreadArray([], ids, true), [parent.id], false);
        if (parent.parent) {
            ids = getParents(parent.parent, ids);
        }
        return ids;
    };
    return (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "ui-input" }, { children: [(0, jsx_runtime_1.jsx)("input", { type: "text", placeholder: props.placeholder, className: "input mb-2", value: searchTerm, onChange: handleChange }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { className: "ui-input__icon", symbol: IconSymbols_1.IconSymbols.Search, size: enums_1.UiSizes.MD })] })), (0, jsx_runtime_1.jsx)(TreePicker_1.TreePicker, __assign({ data: treeData, searchTerm: searchTerm, onItemSelected: onItemSelected }, checkTreeProps))] });
};
exports.SearchTreePicker = SearchTreePicker;
